import { render, staticRenderFns } from "./MarcaVeiculo.vue?vue&type=template&id=0adbe8d4"
import script from "./MarcaVeiculo.vue?vue&type=script&lang=js"
export * from "./MarcaVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports